import { BKBNThemeWrapper } from '../BKBNThemeWrapper'
import { FC } from 'react'
import { RescheduleOrderController } from './RescheduleOrder.controller'

export const RescheduleOrder: FC = () => {
  return (
    <BKBNThemeWrapper>
      <RescheduleOrderController />
    </BKBNThemeWrapper>
  )
}
